// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"AO-z","inlineTitle":"BO-z","sponsoredAdsWrapper":"CO-z","marketplaceRecosWrapper":"DO-z"};